import { CommitmentsRecommendationsFilters } from "@/store/commitments/utils/types/types";

export const recommendationsDefaultFilters: CommitmentsRecommendationsFilters =
  {
    account_ids: [],
    term_in_years: ["one_year"],
    account_scope: "payer",
    type: ["ec2_instance"],
    look_back_period: ["thirty_days"],
    payment_option: ["no_upfront"],
  };

export const reservationsRecommendationsDefaultFilters: CommitmentsRecommendationsFilters =
  {
    account_ids: [],
    term_in_years: ["one_year"],
    account_scope: "payer",
    type: ["ec2", "rds", "elasticache", "opensearch"],
    look_back_period: ["thirty_days"],
    payment_option: ["no_upfront"],
  };
